export default __webpack_public_path__ + "static/media/profile1.eb28d08f.png";